import { FormStructure } from '@europrocurement/flexy-form/components';
import { jsonHeader } from '../types/formTypes';

const jsonHeaderToFormElement: (header: jsonHeader) => FormStructure = (header) => {
    const baseField: FormStructure = {
        type: header.type,
        label: header.label,
        name: header.name,
        variant: header.variant || 'l2dh4',
        outlined: false,
        xs: header.xs,
        sm: header.sm,
        md: header.md,
        lg: header.lg,
    };

    // comportement sur rules display
    if (header.rules && header.rules.display) {
        if (header.rules.display.fieldIsEqualTo) {
            const fieldNameToWatch = header.rules.display.fieldIsEqualTo.field;
            const valueToWatch = header.rules.display.fieldIsEqualTo.value;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, valueToWatch, fieldNameToWatch);
        }
        if (header.rules.display.isTrue) {
            const fieldNameToWatch = header.rules.display.isTrue;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
        if (header.rules.display.fieldIsChecked) {
            const fieldNameToWatch = header.rules.display.fieldIsChecked;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
        if (header.rules.display.fieldIsNotChecked) {
            const fieldNameToWatch = header.rules.display.fieldIsNotChecked;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, false, fieldNameToWatch);
        }
    }

    return baseField;
};

export default jsonHeaderToFormElement;
